import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import UnityWebViewer from "../components/UnityWebViewer";
import { validateTeacherSession } from "../services/teacherSession";

const MAX_REFRESH_DELAY_MS = 2_147_000_000;

const EmbedPage = () => {
  const { experienceId } = useParams();
  const [session, setSession] = useState(null);
  const [sessionError, setSessionError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    let refreshTimer = null;

    const verifySession = async () => {
      try {
        const nextSession = await validateTeacherSession();
        if (cancelled) return;

        setSession(nextSession);
        setSessionError(null);
        clearTimeout(refreshTimer);

        const expiresAt = new Date(nextSession.expiresAt).getTime();
        if (Number.isFinite(expiresAt)) {
          const refreshDelay = Math.min(
            MAX_REFRESH_DELAY_MS,
            Math.max(15_000, expiresAt - Date.now() - 60_000),
          );
          refreshTimer = setTimeout(verifySession, refreshDelay);
        }
      } catch (error) {
        if (cancelled) return;
        clearTimeout(refreshTimer);
        setSession(null);
        setSessionError(error);
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        void verifySession();
      }
    };

    void verifySession();
    window.addEventListener("focus", verifySession);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      cancelled = true;
      clearTimeout(refreshTimer);
      window.removeEventListener("focus", verifySession);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  if (sessionError) {
    return (
      <div className="App" role="alert">
        <p>{sessionError.message}</p>
      </div>
    );
  }

  if (!session) {
    return (
      <div className="App" role="status">
        Verifying dashboard session...
      </div>
    );
  }

  return (
    <div className="App">
      <UnityWebViewer
        experienceId={experienceId}
        experienceRequestMode="teacher"
        userData={session.userData}
        embed
      />
    </div>
  );
};

export default EmbedPage;
